import _ from 'lodash-es';
import templateModalKjson from '../modal/modal-kjson.html';
import ModalKjsonController from '../modal/modal-kjson.controller';

export default class OoAdminKjsonController {
	/* @ngInject */
	/**
	 * @param {import('angular').ITimeoutService} $timeout
	 * @param {import('angular').ui.bootstrap.IModalService} $uibModal
	 */
	constructor($timeout, $uibModal) {
		this.$timeout = $timeout;
		this.$uibModal = $uibModal;

		/** @type {any} */
		this.kjson = undefined;

		/** @type {string} */
		this.class = '';

		/** @type {string} */
		this.icon = '';

		/** @type {string} */
		this.label = '';

		/** @type {?import('angular').IFormController} */
		this.form = null;

		/** @type {?Function} */
		this.onChange = null;

		/** @type {boolean} */
		this.disabled = false;

		/** @type {?import('angular').INgModelController} */
		this.ngModelCtrl = null;
	}

	$onInit() {
		if (!this.label) {
			this.label = 'KJSON';
		}
		if (!this.class.split(/\s+/).some(c => /^btn_(xs|sm|lg)$/.test(c))) {
			this.class += ' btn-sm';
		}
	}

	isEmpty() {
		return _.isEqual(this.kjson, {}) || this.kjson === '' || this.kjson === null || this.kjson === undefined;
	}

	async select() {
		const data = await this.$uibModal.open({
			template:     templateModalKjson,
			controller:   ModalKjsonController,
			controllerAs: '$ctrl',
			resolve:      {
				label:    () => this.label,
				disabled: () => this.disabled,
				kjson:    () => {
					if (this.kjson && typeof this.kjson === 'object') {
						return this.kjson;
					}
					try {
						this.kjson = JSON.parse(this.kjson);
					}
					catch { /* empty */ }

					return this.kjson;
				},
			},
		}).result;

		if (data) {
			const onChange = this.form && !_.isEqual(this.kjson, data.kjson);
			this.ngModelCtrl?.$setViewValue(data.kjson);
			if (onChange) {
				if (typeof this.onChange === 'function') {
					this.$timeout(() => this.onChange);
				}
				this.form?.$setDirty();
			}
		}
	}
}
